import { graphql, commitMutation } from 'react-relay';

const commit = (environment, args) => {
    const AccountSettings = require('./AccountSettings').default; // eslint-disable-line no-unused-vars
    const PinterestPinIcon = require('../Pinterest/PinterestPinIcon').default; // eslint-disable-line no-unused-vars

    const mutation = graphql`
        mutation ModifySocialNetworkConnectionMutation_esMutation(
            $input: ModifySocialNetworkConnectionInput!
        ) {
            modifySocialNetworkConnection(input: $input) {
                removedId
                user {
                    ...AccountSettings_user
                    ...PinterestPinIcon_user
                }
            }
        }
    `;

    const {
        action,
        userId,
        userSocialNetworkId,
        socialNetworkName,
        accessToken,
        onSuccess = () => {},
        onFailure = () => {},
    } = args;

    let input = {
        userId,
        action,
    };

    const configs = [];

    if (action === 'DISCONNECT') {
        configs.push({
            type: 'NODE_DELETE',
            deletedIDFieldName: 'removedId',
        });

        input = {
            ...input,
            userSocialNetworkId,
        };
    } else if (action === 'CONNECT') {
        input = {
            ...input,
            socialNetworkName,
            accessToken,
        };
    }

    commitMutation(environment, {
        mutation,
        configs,
        variables: { input },
        onCompleted: (payload, errors) => {
            if (errors) {
                onFailure(errors);
                return;
            }
            onSuccess(payload);
        },
        onError: error => {
            onFailure([error]);
        },
    });
};

export default { commit };



// WEBPACK FOOTER //
// ./assets/js/global/components/SocialNetworks/ModifySocialNetworkConnectionMutation.es.js